import gql from 'graphql-tag';

export const GET_ACCOUNT_HOLDERS = gql`
  query GetAccountHolders($companyId: ID!) {
    company: Company(id: $companyId) {
      id
      visibleVMCategories
      adyenAccountHolders {
        id
      }
    }
  }
`;

export const GET_ACCOUNT_HOLDERS_ONBOARDING = gql`
  query GetAccountHoldersOnboarding($companyId: ID!) {
    company: Company(id: $companyId) {
      id
      adyenAccountHolders {
        id
        onboardingUrl(returnUrl: "https://vm.baemingo.se")
      }
    }
  }
`;

export const GET_COMPANY = gql`
  query GetCompany($companyId: ID!, $startDate: String!, $endDate: String!) {
    company: Company(id: $companyId) {
      id
      visibleVMCategories
      adyenAccountHolders {
        id
        name
        payouts(startDate: $startDate, endDate: $endDate) {
          id
        }
        kycVerifications {
          type
          status
          updatedAt
        }
      }
    }
  }
`;

export const GET_ITEMS = gql`
  query getItems($companyId: String!) {
    getItems(companyId: $companyId) {
      results {
        id
      }
    }
  }
`;

export const GET_MENUS = gql`
  query getAllMenu($companyId: ID) {
    menus: allMenus(filter: { deleted: false, company: { id: $companyId } }) {
      id
    }
  }
`;

export const GET_VENUES = gql`
  query getVenues($companyId: ID!) {
    venues: allVenues(filter: { deleted: false, company: { id: $companyId } }) {
      id
    }
  }
`;
